/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetMeshRunsQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
  startDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
  endDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
}>;


export type GetMeshRunsQueryGQLType = (
  { __typename?: 'Query' }
  & { getMeshRuns: Array<(
    { __typename?: 'MeshRun' }
    & Pick<Types.MeshRunGQLType, 'meshRunId' | 'status' | 'startedAt' | 'lpSlugs' | 'cfSlugs'>
    & { pipeline: (
      { __typename?: 'PipelineRun' }
      & Pick<Types.PipelineRunGQLType, 'reportingDate' | 'fileVersion' | 'pipelineRunId' | 'artifactDocumentId'>
    ) }
  )> }
);

export type GetMeshInstancesQueryVariablesGQLType = Types.Exact<{
  meshRunId: Types.Scalars['String'];
}>;


export type GetMeshInstancesQueryGQLType = (
  { __typename?: 'Query' }
  & { meshInstances: Types.QueryGQLType['getMeshInstances'] }
);

export type GetMeshDocumentQueryVariablesGQLType = Types.Exact<{
  meshRunId: Types.Scalars['String'];
}>;


export type GetMeshDocumentQueryGQLType = (
  { __typename?: 'Query' }
  & { meshDocument: Types.QueryGQLType['getMeshRunDocument'] }
);

export type GetDataPipelineSignedUrlQueryVariablesGQLType = Types.Exact<{
  serializedParams: Types.Scalars['String'];
}>;


export type GetDataPipelineSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { downloadUrls: Array<(
    { __typename?: 'UrlAndFilename' }
    & Pick<Types.UrlAndFilenameGQLType, 'url' | 'filename'>
  )> }
);


export const GetMeshRunsDocumentGQLType = gql`
    query GetMeshRuns($organizationId: UUID!, $startDate: FullDateStr, $endDate: FullDateStr) {
  getMeshRuns(
    organizationId: $organizationId
    startDate: $startDate
    endDate: $endDate
  ) {
    meshRunId
    status
    startedAt
    lpSlugs
    cfSlugs
    pipeline {
      reportingDate
      fileVersion
      pipelineRunId
      artifactDocumentId
    }
  }
}
    `;

/**
 * __useGetMeshRunsQuery__
 *
 * To run a query within a React component, call `useGetMeshRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeshRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeshRunsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetMeshRunsQuery(baseOptions: Apollo.QueryHookOptions<GetMeshRunsQueryGQLType, GetMeshRunsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeshRunsQueryGQLType, GetMeshRunsQueryVariablesGQLType>(GetMeshRunsDocumentGQLType, options);
      }
export function useGetMeshRunsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetMeshRunsQueryGQLType, GetMeshRunsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeshRunsQueryGQLType, GetMeshRunsQueryVariablesGQLType>(GetMeshRunsDocumentGQLType, options);
        }
export type GetMeshRunsQueryHookResult = ReturnType<typeof useGetMeshRunsQuery>;
export type GetMeshRunsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetMeshRunsLazyQueryGQLType>;
export type GetMeshRunsQueryResultGQLType = Apollo.QueryResult<GetMeshRunsQueryGQLType, GetMeshRunsQueryVariablesGQLType>;
export const GetMeshInstancesDocumentGQLType = gql`
    query GetMeshInstances($meshRunId: String!) {
  meshInstances: getMeshInstances(meshRunId: $meshRunId)
}
    `;

/**
 * __useGetMeshInstancesQuery__
 *
 * To run a query within a React component, call `useGetMeshInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeshInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeshInstancesQuery({
 *   variables: {
 *      meshRunId: // value for 'meshRunId'
 *   },
 * });
 */
export function useGetMeshInstancesQuery(baseOptions: Apollo.QueryHookOptions<GetMeshInstancesQueryGQLType, GetMeshInstancesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeshInstancesQueryGQLType, GetMeshInstancesQueryVariablesGQLType>(GetMeshInstancesDocumentGQLType, options);
      }
export function useGetMeshInstancesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetMeshInstancesQueryGQLType, GetMeshInstancesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeshInstancesQueryGQLType, GetMeshInstancesQueryVariablesGQLType>(GetMeshInstancesDocumentGQLType, options);
        }
export type GetMeshInstancesQueryHookResult = ReturnType<typeof useGetMeshInstancesQuery>;
export type GetMeshInstancesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetMeshInstancesLazyQueryGQLType>;
export type GetMeshInstancesQueryResultGQLType = Apollo.QueryResult<GetMeshInstancesQueryGQLType, GetMeshInstancesQueryVariablesGQLType>;
export const GetMeshDocumentDocumentGQLType = gql`
    query GetMeshDocument($meshRunId: String!) {
  meshDocument: getMeshRunDocument(meshRunId: $meshRunId)
}
    `;

/**
 * __useGetMeshDocumentQuery__
 *
 * To run a query within a React component, call `useGetMeshDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeshDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeshDocumentQuery({
 *   variables: {
 *      meshRunId: // value for 'meshRunId'
 *   },
 * });
 */
export function useGetMeshDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>(GetMeshDocumentDocumentGQLType, options);
      }
export function useGetMeshDocumentLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>(GetMeshDocumentDocumentGQLType, options);
        }
export type GetMeshDocumentQueryHookResult = ReturnType<typeof useGetMeshDocumentQuery>;
export type GetMeshDocumentLazyQueryGQLTypeHookResult = ReturnType<typeof useGetMeshDocumentLazyQueryGQLType>;
export type GetMeshDocumentQueryResultGQLType = Apollo.QueryResult<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>;
export const GetDataPipelineSignedUrlDocumentGQLType = gql`
    query getDataPipelineSignedUrl($serializedParams: String!) {
  downloadUrls: getSignedDownloadUrls(
    feature: "dataPipelineInstanceRecord"
    serializedParams: $serializedParams
  ) {
    url
    filename
  }
}
    `;

/**
 * __useGetDataPipelineSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetDataPipelineSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataPipelineSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataPipelineSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetDataPipelineSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDataPipelineSignedUrlQueryGQLType, GetDataPipelineSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataPipelineSignedUrlQueryGQLType, GetDataPipelineSignedUrlQueryVariablesGQLType>(GetDataPipelineSignedUrlDocumentGQLType, options);
      }
export function useGetDataPipelineSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDataPipelineSignedUrlQueryGQLType, GetDataPipelineSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataPipelineSignedUrlQueryGQLType, GetDataPipelineSignedUrlQueryVariablesGQLType>(GetDataPipelineSignedUrlDocumentGQLType, options);
        }
export type GetDataPipelineSignedUrlQueryHookResult = ReturnType<typeof useGetDataPipelineSignedUrlQuery>;
export type GetDataPipelineSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDataPipelineSignedUrlLazyQueryGQLType>;
export type GetDataPipelineSignedUrlQueryResultGQLType = Apollo.QueryResult<GetDataPipelineSignedUrlQueryGQLType, GetDataPipelineSignedUrlQueryVariablesGQLType>;